import { createContext } from 'react';

const ToolbarDisabledContext = createContext(false);

export default ToolbarDisabledContext;
